
import { Component, Emit, Vue, Prop } from 'vue-property-decorator'
import AppTableHeaderRow from '@/components/AppTableHeaderRow.vue'
import AppTableDefaultRow from '@/components/AppTableDefaultRow.vue'

@Component({
    components: {
        AppTableHeaderRow,
        AppTableDefaultRow,
    },
})
export default class AppTable extends Vue {
    @Prop() private content!: Iterable<Iterable<any>>
    @Prop() private headers!: string[]
}
